export enum AuthUserPerfilId {
  AssessorAdmin = 'assembleia_fundos_admin',
  AssessorConsulta = 'assembleia_fundos_consulta',
  AssessorGestao = 'assembleia_fundos_gestao',
  Associado = 'ASSOCIADO',
  AssociadoConvidado = 'CONVIDADO',
  Deslogado = 'deslogado'
}

export interface IAuthUserPerfil {
  id: AuthUserPerfilId,
  nome: string,

  associadoRoute: {
    assembleias: {
      pre: {
        ver: boolean,
        videos: {
          ver: boolean,
          participar: boolean
        },
        documentos: {
          ver: boolean,
          participar: boolean,
        },
        duvidasSugestoes: {
          ver: boolean,
          participar: boolean
        }
      },
      live: {
        ver: boolean,
        video: {
          ver: boolean,
          participar: boolean
        },
        documentos: {
          ver: boolean,
          participar: boolean,
        },
        duvidasSugestoes: {
          ver: boolean,
          participar: boolean
        }
      },
      pautas: {
        ver: boolean,
        participar: boolean,
      },
    },
  },

  assessorRoute: {
    convocados: {
      view: boolean;
    };
    assembleias: {
      ver: boolean,
      alterarSituacao: boolean,
      bloquearConvocacao: boolean;
      convocar: boolean;
      documentos: {
        ver: boolean,
        editar: boolean,
      },
      participantes: {
        verTotal: boolean,
        confirmar: boolean
      },
      pautas: {
        ver: boolean,
        alterarSituacao: boolean,
        incluirVotoManual: boolean,
        editar: boolean,
        deletar: boolean
      },
      cadastroPauta: {
        cadastrar: boolean
      },
      videos: {
        editar: boolean,
      },
    },

    duvidasSugestoes: {
      ver: boolean,
      responder: boolean,
      alterarSituacao: boolean,
      incluirPergunta: boolean,
    }
  }

}